import { REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT, REDUX_DOMAIN_LIST_SECTION_KEY } from '../../../redux/constants/key'
import getAllPathReduxUtil from '../../../redux/utils/get-all-path'
import { joinPathsStringUtil } from 'packages/src'
import getByProfileIdPathReduxUtil from '../../../redux/utils/get-by-profile-id-path'
import { getDatePeriodStrReduxUtil } from '../get-date-period-str'

const DATE_PERIOD_UNIT_TO_DOMAIN_LIST_PREFIX_FN_MAP = {
  [REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT.YEAR]: REDUX_DOMAIN_LIST_SECTION_KEY.BY_YEAR,
  [REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT.MONTH]: REDUX_DOMAIN_LIST_SECTION_KEY.BY_MONTH,
  [REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT.WEEK]: REDUX_DOMAIN_LIST_SECTION_KEY.BY_WEEK,
  [REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT.DAY]: REDUX_DOMAIN_LIST_SECTION_KEY.BY_DAY
}

export default function getByProfileIdDataPeriodDomainListPathFromDomainPathReduxUtil ({
  profileId,
  domainPath,
  datePeriodUnit,
  date
}) {
  const domainListDatePeriodPrefix = DATE_PERIOD_UNIT_TO_DOMAIN_LIST_PREFIX_FN_MAP[datePeriodUnit]
  const datePeriod = getDatePeriodStrReduxUtil(new Date(date), datePeriodUnit)
  const domainListPathByProfileId = getByProfileIdPathReduxUtil(domainPath, profileId)
  const domainListDatePeriodPath = joinPathsStringUtil(
    domainListPathByProfileId,
    domainListDatePeriodPrefix,
    datePeriod
  )
  return getAllPathReduxUtil(domainListDatePeriodPath)
}
